import React, { useContext } from 'react';
import { Grid, Typography, Paper, makeStyles } from '@material-ui/core';

import {handleStart,handlePauseResume} from './Stopwatch'
import Cook from './Cook';
import { SocketContext } from '../Context';


const useStyles = makeStyles((theme) => ({
  video: {
    
    width: '550px',
    [theme.breakpoints.down('xs')]: {
      width: '300px',
    },
  },
  gridContainer: {
    justifyContent: 'center',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
  paper: {
    backgroundColor:'#B6C2D9',
    padding: '10px',
    border: '3px solid black',
    margin: '10px',
    borderRadius: '10px',
  },
}));

const VideoPlayer = () => {
  const { name, callAccepted, myVideo, userVideo, callEnded, stream, call } = useContext(SocketContext);
  const classes = useStyles();
  if(callAccepted && !callEnded){
    {handleStart()}
    // {handleStart1()}   
  }
  else{
    {handlePauseResume()}
    // {handlePauseResume1()}
  }


  return (
    <Grid container className={classes.gridContainer}>
      {stream && (
        <Paper className={classes.paper}>
          <Grid item xs={12} md={6}>
          <Typography variant="h5">{name || 'Name'}</Typography>
            {/* <Typography variant="h5" gutterBottom>{name || 'Name'}</Typography> */}
            <video playsInline muted ref={myVideo} autoPlay className={classes.video} />
          </Grid>
        </Paper>
      )}
      {callAccepted && !callEnded && (
        <Paper className={classes.paper}>
          <Grid item xs={12} md={6}>
            <Typography variant="h5" gutterBottom>{call.name || 'Name'}</Typography>
            <video playsInline ref={userVideo} autoPlay className={classes.video} />
          </Grid>
        </Paper>
      )}
      {!(callAccepted && !callEnded) && 
      (
        <Cook/>
      )
      }



    </Grid>
  );
};

export default VideoPlayer;

